import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "./CustomerOrderViewPage.css";

function CustomerOrderViewPage() {
  const customer = useSelector((store) => store.customer);
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  // const [subTotal, setSubTotal] = useState(0);
  let subTotal;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  try {
    const getOrder = async () => {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + `/api/orders/${id}`,
        headers: { Authorization: `Bearer ${customer.access_token}` },
      });
      response && setOrder(response.data);
    };

    useEffect(() => {
      getOrder();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  return (
    order && (
      <div className="container orders-container py-sm-5 animate__animated animate__fadeIn text-responsive">
        <div className="d-flex w-100 justify-content-between align-items-center">
          <h2 className="my-4 text-responsive">
            Order#{order.id}
            <span className="ms-3 f-roboto fs-7">
              - Confirmed at {new Date(order.createdAt).toLocaleDateString()}
            </span>
          </h2>
          <Link
            to={`/customers/${customer.firstname}/orders`}
            className="link-dark-hover text-yellow"
          >
            Back to orders
          </Link>
        </div>
        <div className="table-responsive">
          <table className="table table-borderless border align-middle">
            <thead>
              <tr className="border-bottom bg-yellow text-white">
                <th className="product-col" scope="col">
                  Product
                </th>
                <th className="price-col text-center" scope="col">
                  Price
                </th>
                <th className="quantity-col text-center" scope="col">
                  Quantity
                </th>
                <th className="total-col text-end" scope="col">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="f-roboto">
              {order.products.map((product, i) => (
                <tr key={i} className="border-bottom">
                  <th scope="row" className="py-4">
                    <div className="d-flex flex-row w-75">
                      <div>
                        <p className="mb-0 fw-normal">{product.name}</p>
                      </div>
                    </div>
                  </th>
                  <td className="text-center f-roboto">${product.price}</td>
                  <td className="text-center f-roboto">{product.qty}</td>
                  <td className="text-end f-roboto">
                    ${(product.price * product.qty).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <hr className="my-4 bg-secondary" />
        <div className="d-flex justify-content-between mt-4">
          <div className="f-roboto border px-2 py-1">
            <p className="mb-1">
              Customer name: {customer.firstname} {customer.lastname}
            </p>
            <hr className="bg-secondary mt-0 mb-1" />
            <p className="mb-1">Shipping address: {order.shippingAddress}</p>
            <hr className="bg-secondary mt-0 mb-1" />
            <p>Notes:</p>
          </div>
          <table className="w-25 f-roboto border">
            <caption className="visually-hidden">Cost summary</caption>
            <thead>
              <tr>
                <th scope="col">
                  <span className="visually-hidden">Description</span>
                </th>
                <th scope="col">
                  <span className="visually-hidden">Price</span>
                </th>
              </tr>
            </thead>
            <tbody className="total-line-table__tbody">
              <tr className="total-line total-line--subtotal">
                <th className="fw-normal ps-2" scope="row">
                  Subtotal
                </th>
                <td className="text-end pe-2">
                  <span>
                    $
                    {
                      (subTotal = order.products
                        .reduce(
                          (acc, product) => acc + product.qty * product.price,
                          0
                        )
                        .toFixed(2))
                    }
                  </span>
                </td>
              </tr>
              <tr className="total-line total-line--shipping">
                <th className="fw-normal ps-2" scope="row">
                  <span>Shipping</span>
                </th>
                <td className="text-end pe-2">
                  <span>Free shipping</span>
                </td>
              </tr>
              <tr className="total-line total-line--shipping">
                <th className="fw-normal pb-4 ps-2" scope="row">
                  <span>Taxes</span>
                </th>
                <td className="pb-4 text-end pe-2">
                  <span>+10%</span>
                </td>
              </tr>
              <tr className="visually-hidden">
                <th scope="row">Taxes (estimated)</th>
                <td>
                  <span>$0.00</span>
                </td>
              </tr>
            </tbody>
            <tfoot className="border-top">
              <tr className="total-line">
                <th className="pt-4" scope="row">
                  <span className="fw-normal ps-2">Total</span>
                </th>
                <td className="text-end pt-4">
                  <span className="fs-8">CAD</span>
                  <span className="fs-4 fw-bold ms-2 pe-2">
                    ${(subTotal * 1.1).toFixed(2)}
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="text-end">
          <button className="btn btn-outline-secondary f-roboto mt-4 ms-auto">
            Print
          </button>
        </div>
      </div>
    )
  );
}

export default CustomerOrderViewPage;
